var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect3, _rect4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJdfxLogoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1835",
    "data-name": "Group 1835",
    xmlns: "http://www.w3.org/2000/svg",
    width: 638.795,
    height: 632.384,
    viewBox: "0 0 638.795 632.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M633.688,316.188c0,173.583-140.717,314.3-314.3,314.3s-314.3-140.717-314.3-314.3,140.717-314.3,314.3-314.3,314.3,140.717,314.3,314.3",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M52.5,253.929l1.142-6.061,25.535,4.809q10.951,2.064,12.867,6.3,1.606,3.57-.833,16.524-2.375,12.6-5.577,15.564-3.582,3.328-13.925,1.378l1.142-6.06q7.017,1.32,9.04-.448t3.858-11.494q1.832-9.729.6-12.046t-8.314-3.654Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M52.5,253.929l1.142-6.061,25.535,4.809q10.951,2.064,12.867,6.3,1.606,3.57-.833,16.524-2.375,12.6-5.577,15.564-3.582,3.328-13.925,1.378l1.142-6.06q7.017,1.32,9.04-.448t3.858-11.494q1.832-9.729.6-12.046t-8.314-3.654Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M87.454,236.89q4.455,1.906,6.545-.129t6.651-12.713q4.615-10.788,4.63-13.674t-4.441-4.793L73.822,194.033l2.424-5.673,27.011,11.546q7.852,3.358,8.3,7.233.531,4.3-5.791,19.1-6.3,14.736-9.6,17.211t-11.149-.887L58.013,231.015l2.424-5.673Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M87.454,236.89q4.455,1.906,6.545-.129t6.651-12.713q4.615-10.788,4.63-13.674t-4.441-4.793L73.822,194.033l2.424-5.673,27.011,11.546q7.852,3.358,8.3,7.233.531,4.3-5.791,19.1-6.3,14.736-9.6,17.211t-11.149-.887L58.013,231.015l2.424-5.673Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M112.755,165.894q8.552-11.656,12.133-13.677,4.459-2.506,10.946,2.253,6.147,4.5,4.723,10.437-1.157,4.851-9.456,16.166-8.978,12.243-14.234,13.784-4.017,1.182-10.893-3.861l3.648-4.976q4.729,3.473,7.464,2.25t9.563-10.538q6.687-9.117,7.8-12.471t-2.258-5.816q-3.414-2.507-5.727-1.089t-9.216,10.829Q108.8,180.7,103.125,182.606q-4.315,1.489-9.776-2.52-5.9-4.324-4.97-9.231t9.16-16.121q8.193-11.167,13.45-12.713,4.185-1.2,10.426,3.373l-3.578,4.877q-4.32-3.169-7.062-1.8t-8.747,9.557q-5.151,7.023-6.137,8.777-2.986,5.309,1.077,8.292,3.43,2.514,6.587.779t9.2-9.979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M112.755,165.894q8.552-11.656,12.133-13.677,4.459-2.506,10.946,2.253,6.147,4.5,4.723,10.437-1.157,4.851-9.456,16.166-8.978,12.243-14.234,13.784-4.017,1.182-10.893-3.861l3.648-4.976q4.729,3.473,7.464,2.25t9.563-10.538q6.687-9.117,7.8-12.471t-2.258-5.816q-3.414-2.507-5.727-1.089t-9.216,10.829Q108.8,180.7,103.125,182.606q-4.315,1.489-9.776-2.52-5.9-4.324-4.97-9.231t9.16-16.121q8.193-11.167,13.45-12.713,4.185-1.2,10.426,3.373l-3.578,4.877q-4.32-3.169-7.062-1.8t-8.747,9.557q-5.151,7.023-6.137,8.777-2.986,5.309,1.077,8.292,3.43,2.514,6.587.779T112.755,165.894Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M122.214,125.014,154.7,96.471l3.674,4.179-13.9,12.215,23.673,26.941-4.635,4.072-23.673-26.941-13.947,12.257Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M122.214,125.014,154.7,96.471l3.674,4.179-13.9,12.215,23.673,26.941-4.635,4.072-23.673-26.941-13.947,12.257Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M196.739,69.876l32.448-12.339q7.181-2.73,10.792-1.057,5.354,2.5,10.195,15.241Q255,84.4,252.657,89.828q-1.564,3.7-8.747,6.435L211.463,108.6Zm18.512,31.331,26.626-10.125q4.692-1.785,5.217-5.257t-2.686-11.913q-3.189-8.384-5.926-10.649t-7.374-.5L204.482,72.882Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M196.739,69.876l32.448-12.339q7.181-2.73,10.792-1.057,5.354,2.5,10.195,15.241Q255,84.4,252.657,89.828q-1.564,3.7-8.747,6.435L211.463,108.6Zm18.512,31.331,26.626-10.125q4.692-1.785,5.217-5.257t-2.686-11.913q-3.189-8.384-5.926-10.649t-7.374-.5L204.482,72.882Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M262.189,47.507,301.48,42.45l.711,5.518-33.173,4.27,1.544,12L302.6,60.113l.709,5.518-32.032,4.123,1.615,12.538,33.171-4.272.711,5.518L267.479,88.6Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M262.189,47.507,301.48,42.45l.711,5.518-33.173,4.27,1.544,12L302.6,60.113l.709,5.518-32.032,4.123,1.615,12.538,33.171-4.272.711,5.518L267.479,88.6Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M341.544,61.643q14.4,1.287,17.983,3.3,4.45,2.523,3.735,10.535-.675,7.59-6.488,9.439-4.75,1.52-18.726.273-15.125-1.35-19.162-5.048-3.087-2.828-2.331-11.321l6.145.549q-.523,5.842,1.938,7.548T338.6,79.657q11.265,1.008,14.7.22t3.811-4.942q.379-4.219-2.031-5.465t-14.034-2.284q-14.221-1.269-18.791-5.138-3.505-2.924-2.9-9.669.649-7.29,5.33-9.029t18.534-.5q13.791,1.227,17.837,4.93,3.193,2.958,2.509,10.668l-6.025-.537q.477-5.342-2.109-6.981t-12.707-2.54q-8.673-.771-10.685-.708-6.087.189-6.536,5.211-.379,4.236,2.739,6.039t13.3,2.711"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M341.544,61.643q14.4,1.287,17.983,3.3,4.45,2.523,3.735,10.535-.675,7.59-6.488,9.439-4.75,1.52-18.726.273-15.125-1.35-19.162-5.048-3.087-2.828-2.331-11.321l6.145.549q-.523,5.842,1.938,7.548T338.6,79.657q11.265,1.008,14.7.22t3.811-4.942q.379-4.219-2.031-5.465t-14.034-2.284q-14.221-1.269-18.791-5.138-3.505-2.924-2.9-9.669.649-7.29,5.33-9.029t18.534-.5q13.791,1.227,17.837,4.93,3.193,2.958,2.509,10.668l-6.025-.537q.477-5.342-2.109-6.981t-12.707-2.54q-8.673-.771-10.685-.708-6.087.189-6.536,5.211-.379,4.236,2.739,6.039T341.544,61.643Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2313",
    "data-name": "Rectangle 2313",
    width: 41.43,
    height: 6.169,
    transform: "translate(371.078 89.598) rotate(-76.205)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2314",
    "data-name": "Rectangle 2314",
    width: 41.43,
    height: 6.169,
    transform: "translate(371.078 89.598) rotate(-76.205)",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M399.063,75.087Q394.574,85.626,396,88.6t13.672,8.19q11.964,5.093,15.032,4.753t6.075-7.4L412.42,86.326l2.179-5.119,24.042,10.232-2.174,5.107q-4.182,9.822-9.287,10.7t-19.685-5.329q-14.8-6.3-17.2-11.326t3.116-17.972q5.51-12.948,10.73-14.631t20.078,4.641q14.636,6.227,17.68,10.122t-.605,12.459l-5.676-2.416q2.358-5.547.177-7.832t-13.756-7.215q-12.352-5.256-15.409-4.252t-7.566,11.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M399.063,75.087Q394.574,85.626,396,88.6t13.672,8.19q11.964,5.093,15.032,4.753t6.075-7.4L412.42,86.326l2.179-5.119,24.042,10.232-2.174,5.107q-4.182,9.822-9.287,10.7t-19.685-5.329q-14.8-6.3-17.2-11.326t3.116-17.972q5.51-12.948,10.73-14.631t20.078,4.641q14.636,6.227,17.68,10.122t-.605,12.459l-5.676-2.416q2.358-5.547.177-7.832t-13.756-7.215q-12.352-5.256-15.409-4.252T399.063,75.087Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M464.49,82.388l7.141,5.5,5.982,50.412,22.143-28.75,4.885,3.766-25.278,32.822-7.38-5.684-5.926-49.989-21.96,28.51-4.889-3.766Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M464.49,82.388l7.141,5.5,5.982,50.412,22.143-28.75,4.885,3.766-25.278,32.822-7.38-5.684-5.926-49.989-21.96,28.51-4.889-3.766Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M509.3,131.59l.045-.042a10.526,10.526,0,1,1,14.112,15.621l-.045.039A10.525,10.525,0,1,1,509.3,131.59m13.3,14.718.046-.039a9.318,9.318,0,1,0-12.5-13.821l-.044.042a9.316,9.316,0,1,0,12.5,13.818m-4.758-13.534,3.153,3.51c1.454,1.62,1.771,3.693.2,5.108a3.255,3.255,0,0,1-4.123.208l-1.078,4.955-1.416-1.575,1.1-4.567-1.7-1.89L511.1,141.11l-1.131-1.26Zm-.928,6.933c1.009,1.125,2.16,1.229,3.014.461.945-.849.791-1.926-.18-3.006l-1.9-2.115-2.834,2.545Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M509.3,131.59l.045-.042a10.526,10.526,0,1,1,14.112,15.621l-.045.039A10.525,10.525,0,1,1,509.3,131.59Zm13.3,14.718.046-.039a9.318,9.318,0,1,0-12.5-13.821l-.044.042a9.316,9.316,0,1,0,12.5,13.818Zm-4.758-13.534,3.153,3.51c1.454,1.62,1.771,3.693.2,5.108a3.255,3.255,0,0,1-4.123.208l-1.078,4.955-1.416-1.575,1.1-4.567-1.7-1.89L511.1,141.11l-1.131-1.26Zm-.928,6.933c1.009,1.125,2.16,1.229,3.014.461.945-.849.791-1.926-.18-3.006l-1.9-2.115-2.834,2.545Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M537.126,193.046l-15.55,7.577-2.7-5.544,37.24-18.154,16.827,34.523-5,2.439-14.125-28.978-11.688,5.7L555.722,218.5l-5,2.439Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M537.126,193.046l-15.55,7.577-2.7-5.544,37.24-18.154,16.827,34.523-5,2.439-14.125-28.978-11.688,5.7L555.722,218.5l-5,2.439Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M552.769,241.247q-4.713,1.131-5.175,4.011t2.253,14.169q2.742,11.408,4.452,13.734t6.424,1.195l28.569-6.865,1.44,6-28.561,6.865q-8.3,2-10.98-.846-3-3.14-6.753-18.78-3.746-15.584-2.576-19.532t9.47-5.946l28.564-6.865,1.44,6Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M552.769,241.247q-4.713,1.131-5.175,4.011t2.253,14.169q2.742,11.408,4.452,13.734t6.424,1.195l28.569-6.865,1.44,6-28.561,6.865q-8.3,2-10.98-.846-3-3.14-6.753-18.78-3.746-15.584-2.576-19.532t9.47-5.946l28.564-6.865,1.44,6Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M592.721,289.333l.754,43.237-5.563.1-.321-18.5-35.86.624-.109-6.168,35.859-.624-.323-18.565Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M592.721,289.333l.754,43.237-5.563.1-.321-18.5-35.86.624-.109-6.168,35.859-.624-.323-18.565Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M562.472,347.366q-4.75-.966-6.384,1.448t-3.949,13.793q-2.337,11.5-1.769,14.33t5.315,3.8l28.792,5.855-1.229,6.047-28.786-5.855q-8.37-1.705-9.594-5.409-1.387-4.109,1.82-19.873,3.194-15.706,5.923-18.793t11.1-1.384l28.787,5.856-1.232,6.044Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M562.472,347.366q-4.75-.966-6.384,1.448t-3.949,13.793q-2.337,11.5-1.769,14.33t5.315,3.8l28.792,5.855-1.229,6.047-28.786-5.855q-8.37-1.705-9.594-5.409-1.387-4.109,1.82-19.873,3.194-15.706,5.923-18.793t11.1-1.384l28.787,5.856-1.232,6.044Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M578.22,409.283l-15.838,33.59a9.727,9.727,0,0,1-6.716,5.793q-4.472,1.034-9.891-1.524-4.658-2.195-6.261-4.756a7.864,7.864,0,0,1-1.055-4.576,9.125,9.125,0,0,1-3.634,2.163,7.421,7.421,0,0,1-5.377-.529l-9.205-4.34,2.629-5.58,9.228,4.351a4.069,4.069,0,0,0,3.94-.312,8.1,8.1,0,0,0,3.257-3.7l12.387-26.269L538.119,397.2l2.63-5.58Zm-21.5-3.319-12.13,25.723a8.436,8.436,0,0,0-1.069,4.97q.591,2.877,4.874,4.9t6.8.67a8.394,8.394,0,0,0,3.237-4.014l12.128-25.723Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M578.22,409.283l-15.838,33.59a9.727,9.727,0,0,1-6.716,5.793q-4.472,1.034-9.891-1.524-4.658-2.195-6.261-4.756a7.864,7.864,0,0,1-1.055-4.576,9.125,9.125,0,0,1-3.634,2.163,7.421,7.421,0,0,1-5.377-.529l-9.205-4.34,2.629-5.58,9.228,4.351a4.069,4.069,0,0,0,3.94-.312,8.1,8.1,0,0,0,3.257-3.7l12.387-26.269L538.119,397.2l2.63-5.58Zm-21.5-3.319-12.13,25.723a8.436,8.436,0,0,0-1.069,4.97q.591,2.877,4.874,4.9t6.8.67a8.394,8.394,0,0,0,3.237-4.014l12.128-25.723Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M547.847,468.678l-24.6,31.056-4.363-3.454,20.765-26.218-9.484-7.51-20.05,25.319-4.362-3.457L525.811,459.1l-9.911-7.847-20.765,26.218-4.359-3.454,24.592-31.055Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M547.847,468.678l-24.6,31.056-4.363-3.454,20.765-26.218-9.484-7.51-20.05,25.319-4.362-3.457L525.811,459.1l-9.911-7.847-20.765,26.218-4.359-3.454,24.592-31.055Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M485.03,535.284l-33.4,21.291-2.993-4.692,28.2-17.977-6.5-10.2L443.1,541.067l-2.99-4.695,27.234-17.358-6.792-10.66-28.2,17.978-2.993-4.691,33.407-21.294Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M485.03,535.284l-33.4,21.291-2.993-4.692,28.2-17.977-6.5-10.2L443.1,541.067l-2.99-4.695,27.234-17.358-6.792-10.66-28.2,17.978-2.993-4.691,33.407-21.294Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M405.284,558.293,394.512,580.02l-8.274,2.9L399.5,556.96l-27.377-12.988,7.934-2.785,23.108,11.056.742-.261,11.132-23.071,7.763-2.723-13.256,27.248,26.576,11.984-8.047,2.824-22.044-10.213Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M405.284,558.293,394.512,580.02l-8.274,2.9L399.5,556.96l-27.377-12.988,7.934-2.785,23.108,11.056.742-.261,11.132-23.071,7.763-2.723-13.256,27.248,26.576,11.984-8.047,2.824-22.044-10.213Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M366.668,544.964l4.12,41.226-33.581,3.355q-5.477.549-8.9-2.407t-4.089-9.6q-.666-6.652,2.171-10.2t8.432-4.109l27.2-2.72-1.494-14.923Zm-4.1,21.077-27.2,2.717a5.3,5.3,0,0,0-4.03,2.241q-1.384,1.975-.99,5.921t2.115,5.639a5.31,5.31,0,0,0,4.486,1.42l27.143-2.714Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M366.668,544.964l4.12,41.226-33.581,3.355q-5.477.549-8.9-2.407t-4.089-9.6q-.666-6.652,2.171-10.2t8.432-4.109l27.2-2.72-1.494-14.923Zm-4.1,21.077-27.2,2.717a5.3,5.3,0,0,0-4.03,2.241q-1.384,1.975-.99,5.921t2.115,5.639a5.31,5.31,0,0,0,4.486,1.42l27.143-2.714Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M309.349,590.651,270,586.058l.644-5.526,33.219,3.878,1.4-12.015-32.079-3.743.646-5.527,32.077,3.743,1.465-12.555-33.218-3.875.644-5.527,39.347,4.59Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M309.349,590.651,270,586.058l.644-5.526,33.219,3.878,1.4-12.015-32.079-3.743.646-5.527,32.077,3.743,1.465-12.555-33.218-3.875.644-5.527,39.347,4.59Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M250.833,582.565l-34.926-12.62a9.724,9.724,0,0,1-6.4-6.142q-1.447-4.359.587-9.993,1.752-4.844,4.152-6.677a7.817,7.817,0,0,1,4.455-1.479,9.12,9.12,0,0,1-2.5-3.418,7.422,7.422,0,0,1,.023-5.4l3.459-9.573,5.8,2.095-3.468,9.6a4.063,4.063,0,0,0,.681,3.893,8.084,8.084,0,0,0,3.994,2.894l27.312,9.869,5.1-14.1,5.8,2.1Zm1.288-21.721-26.747-9.664a8.435,8.435,0,0,0-5.048-.6q-2.811.852-4.422,5.31t-.031,6.832a8.43,8.43,0,0,0,4.3,2.846l26.744,9.664Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M250.833,582.565l-34.926-12.62a9.724,9.724,0,0,1-6.4-6.142q-1.447-4.359.587-9.993,1.752-4.844,4.152-6.677a7.817,7.817,0,0,1,4.455-1.479,9.12,9.12,0,0,1-2.5-3.418,7.422,7.422,0,0,1,.023-5.4l3.459-9.573,5.8,2.095-3.468,9.6a4.063,4.063,0,0,0,.681,3.893,8.084,8.084,0,0,0,3.994,2.894l27.312,9.869,5.1-14.1,5.8,2.1Zm1.288-21.721-26.747-9.664a8.435,8.435,0,0,0-5.048-.6q-2.811.852-4.422,5.31t-.031,6.832a8.43,8.43,0,0,0,4.3,2.846l26.744,9.664Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2315",
    "data-name": "Rectangle 2315",
    width: 41.428,
    height: 6.17,
    transform: "translate(184.299 554.347) rotate(-60.825)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2316",
    "data-name": "Rectangle 2316",
    width: 41.428,
    height: 6.17,
    transform: "translate(184.299 554.347) rotate(-60.825)",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M171.036,547.358l-31.492-24.033,3.375-4.424,26.587,20.289,7.341-9.615-25.676-19.592,3.375-4.425,25.676,19.592,7.667-10.046L161.3,494.815l3.375-4.424,31.492,24.033Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M171.036,547.358l-31.492-24.033,3.375-4.424,26.587,20.289,7.341-9.615-25.676-19.592,3.375-4.425,25.676,19.592,7.667-10.046L161.3,494.815l3.375-4.424,31.492,24.033Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M124.452,510.348l-5.69-6.986,5.71-50.443-28.134,22.92-3.895-4.785,32.119-26.164,5.883,7.219-5.67,50.018,27.9-22.728,3.9,4.784Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M124.452,510.348l-5.69-6.986,5.71-50.443-28.134,22.92-3.895-4.785,32.119-26.164,5.883,7.219-5.67,50.018,27.9-22.728,3.9,4.784Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M97.511,439.276q10.29-4.75,11.256-7.864t-4.233-14.366q-4.843-10.488-7.062-12.26-2.616-2.058-8.654.731l-2.588-5.6q8.952-4.135,13-1.505t10.358,16.3q6.417,13.893,4.821,19.092t-14.279,11.056q-12.741,5.885-17.747,3.766T70.93,432.565q-6.34-13.728-5.757-18.458t9.582-8.89l2.585,5.6q-6.037,2.789-6.134,5.83t4.775,13.582q5.223,11.314,8.179,12.578t13.351-3.533"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M97.511,439.276q10.29-4.75,11.256-7.864t-4.233-14.366q-4.843-10.488-7.062-12.26-2.616-2.058-8.654.731l-2.588-5.6q8.952-4.135,13-1.505t10.358,16.3q6.417,13.893,4.821,19.092t-14.279,11.056q-12.741,5.885-17.747,3.766T70.93,432.565q-6.34-13.728-5.757-18.458t9.582-8.89l2.585,5.6q-6.037,2.789-6.134,5.83t4.775,13.582q5.223,11.314,8.179,12.578T97.511,439.276Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M55.99,394.234l-8.123-38.773,5.445-1.139,6.857,32.734,11.841-2.48-6.623-31.61,5.445-1.142,6.623,31.61,12.372-2.593-6.859-32.735,5.447-1.139,8.123,38.77Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M55.99,394.234l-8.123-38.773,5.445-1.139,6.857,32.734,11.841-2.48-6.623-31.61,5.445-1.142,6.623,31.61,12.372-2.593-6.859-32.735,5.447-1.139,8.123,38.77Z",
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M512.74,292.819c0,106.785-86.567,193.352-193.352,193.352S126.036,399.6,126.036,292.819,212.6,99.467,319.388,99.467,512.74,186.034,512.74,292.819",
    fill: "#d9ff50"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M264.858,315.877s22.134-1.737,26.548-5.808c4.615-4.258,6.642-10.194,6.82-26.877s-.219-67.773-.219-67.773-19.9-1.877-26.677,10.6c0,0-5.746,7.87-5.9,22.369s-.575,67.49-.575,67.49"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M335.216,273.374c.638-21.465,2.657-30.5,4.357-39.21s8.394-15.2,13.495-15.2,7.013,2.55,10.945,8.288,3.294,22,3.294,22l-1.812,56.25s-22.841-.57-26.135-2.057-3.931-7.545-4.144-12.752,0-17.32,0-17.32"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M507.481,317.865a193.158,193.158,0,0,1-35.167,110.744c-21.978,31-52.972,55.224-88.731,68.248-36.734,13.379-77.772,13.987-115.138,2.762A193.144,193.144,0,0,1,158.683,215.641c19.456-32.409,48.757-59.062,83.219-74.713,35.759-16.241,76.176-20.008,114.5-11.786,37.712,8.091,72.457,28.244,98.815,56.305A193.447,193.447,0,0,1,505.273,288.48a199.208,199.208,0,0,1,2.208,29.385c.008,2.961,12.529.889,12.518-3.354A195.928,195.928,0,0,0,388.7,129.979c-39.732-13.913-83.752-14.733-124.145-3.038-38.994,11.29-74.4,33.944-100.4,65.2a195.807,195.807,0,0,0,72.107,304.818c38.295,16.815,81.73,20.781,122.6,12.255A206.315,206.315,0,0,0,464.874,451.1a196.6,196.6,0,0,0,52.8-105.982A204.142,204.142,0,0,0,520,314.511c.008-2.945-12.507-.9-12.518,3.354"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M626.277,317.865a312.287,312.287,0,0,1-57.143,179.6c-35.869,50.51-86.636,89.834-144.9,111.054-60.18,21.916-127.269,23.426-188.621,5.308A311.992,311.992,0,0,1,57.17,153.9c31.893-52.762,79.784-96.022,136.075-121.375,58.575-26.382,124.668-33,187.464-19.688,61.175,12.969,117.606,45.241,160.5,90.641a312.526,312.526,0,0,1,81.436,166.519,318.984,318.984,0,0,1,3.636,47.872c.005,2.958,12.525.891,12.518-3.354A315.009,315.009,0,0,0,429.8,18.473,320.94,320.94,0,0,0,332.1.162,326,326,0,0,0,143.14,53.421a317.939,317.939,0,0,0-119.8,144.911A312.315,312.315,0,0,0,.907,293.442a317.678,317.678,0,0,0,8.175,99.676,312.008,312.008,0,0,0,37.069,88.491A315.431,315.431,0,0,0,281.817,630.533a324.641,324.641,0,0,0,269.039-97.458,317.46,317.46,0,0,0,54.889-77.737,311.73,311.73,0,0,0,29.372-92.22,324.006,324.006,0,0,0,3.678-48.607c.005-2.948-12.511-.895-12.518,3.354"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M170.521,362.743c7.218,6.5,16,8.1,24.5,4.413,5.187-2.3,7.956-6.316,10.857-11.922l.49.005c-.1,14-15.185,22.709-27.557,16.661a19.342,19.342,0,0,1-8.735-8.962Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M438.349,349.582C441.2,364.1,455.6,371.265,468.736,364.2l.385.3c-8.069,10.308-24.219,8.146-29.912-3.413a18.092,18.092,0,0,1-1.335-11.624Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M440.652,357.031c2.163,3.539,4.688,8.453,8.857,9.452l3.249-.064c-1.036,2.374-4.2,10.5-5.279,13.039-4.645,10.074-11.562,18.511-22.495,23.285-13.634,6.328-36.185-.938-42.632-4.944-14.311-5.347-29.209-10.1-42.7-11.717-8.895-.92-17.63.078-25.684,4.055-12.331,6.615-23.589,15.755-34.874,24.238-19.75,14.531-51.455,20.279-69.754.523l1.607,1.32c-7.656-5.21-11.51-12.634-15.047-20.431a103.869,103.869,0,0,1-6.511-22.5l1.1-.345c5.1,13.7,10.951,29.241,23.6,37.6,11.517,10.7,29.927,10.386,43.692,4.261a72.1,72.1,0,0,0,19.58-12.456c9.166-7.479,18.515-14.812,28.734-20.852,10.352-6.386,22.82-8.007,34.774-6.526,15.862,2.045,30.683,7.884,45.224,13.831,17.164,10.179,38.027,13.389,51.958-3.758,4.418-4.669,6.984-10.672,10.241-16.288l.394.911c-5.115-1.9-7.255-7.593-9.125-12.27l1.093-.364"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2317",
    "data-name": "Rectangle 2317",
    width: 638.795,
    height: 632.384,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdfxLogoMenu);
export default __webpack_public_path__ + "static/media/jdfx-logo-menu.7769935762a1b71051e46ded3a2202f2.svg";
export { ForwardRef as ReactComponent };